import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'gotoSlide';

export const DEFAULTS = {
  gotoSlides: '',
  gotoSlideNum: '',
};

const setEventListeners = ($el, opts) => {
  $el.on('click', () => {
    $(opts.gotoSlides).slick('slickGoTo', opts.gotoSlideNum, true);
  });
};

export default function gotoSlide(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, gotoSlide);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/goto-slide.js